import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { URI } from "../../configs";


export const confirmAnomaly = createAsyncThunk(
  "anomaly/confirmedAnomaly",
  async (arg) => { // <-- destructure getState method

    const token = arg.token
    let body = { ...arg }
    delete body.token
    const apiUrl = URI + "api/v1/anomalies/"
    //const apiUrl = "https://test.digitsolution.space/api/v1/token/login/";
    var config = {
      method: "post",
      url: apiUrl,
      data: body,
      headers: {
        accept: "application/json",
        Authorization: `Token ${token}`
      },
    };

    const response = await axios(config);
    const data = await response.data;
    return data;
  }
);

export const updateAnomaly = createAsyncThunk(
  "anomaly/updateAnomaly",
  async (arg) => { // <-- destructure getState method

    const token = arg.token
    const anomaly_id = arg.anomaly_id
    let body = { ...arg }
    delete body.token
    delete body.key
    const apiUrl = URI + "api/v1/anomalies/" + `${anomaly_id}/`
    //const apiUrl = "https://test.digitsolution.space/api/v1/token/login/";
    var config = {
      method: "patch",
      url: apiUrl,
      data: body,
      headers: {
        accept: "application/json",
        Authorization: `Token ${token}`
      },
    };

    const response = await axios(config);
    const data = await response.data;
    return data;
  }
);


export const getAnomalyTable = createAsyncThunk(
  "anomaly/table",
  async (token) => { // <-- destructure getState method

    const apiUrl = URI + "api/v1/anomalies/table/"

    //const apiUrl = "https://test.digitsolution.space/api/v1/token/login/";
    var config = {
      method: "get",
      url: apiUrl,
      headers: {
        accept: "application/json",
        Authorization: `Token ${token}`
      },
    };
    const response = await axios(config);
    const data = await response.data;
    return data;
  }
);


export const getAnomalyForPerformerUser = createAsyncThunk(
  "anomaly/forPerformer",
  async (arg) => { // <-- destructure getState method
    let username = arg.username
    let token = arg.token

    const apiUrl = URI + "api/v1/anomalies/" + `?performer=${username}`

    var config = {
      method: "get",
      url: apiUrl,
      headers: {
        accept: "application/json",
        Authorization: `Token ${token}`
      },
    };

    const response = await axios(config);
    const data = await response.data;
    return data;
  }
);
